module.exports = __webpack_public_path__ + "static/media/opensans-light.2d0bdc8d.ttf";